import { toast } from "react-toastify";
import axios from "axios";
import { GetQueryString } from "../Utils/GetQueryString";
import { FtlRoutingViewModel } from "./ViewModel/FtlRoutingViewModel";
import { combinedUrls } from "../URL/functions";
import { projectUrls } from "../URL/ApplicationUrls";
import { RelationType } from "../TransportNetwork/RelationType";

const getRoutingInfo = async (
  projectId: number,
  supplierGsdb: string | undefined,
  plantGsdb: string | undefined,
  dockCode: string | undefined,
  relationType: RelationType,
  cardType: string
) => {
  const params: any = {
    supplierGsdb,
    plantGsdb,
    dockCode,
    relationType,
  };

  const baseUrl = combinedUrls(projectUrls.projectWithId(projectId).apiUrl, "/GetRoutingInfo");
  const url = new URL(`${baseUrl}?${GetQueryString(params)}`);

  const fetchPromise = axios.get(url.toString());
  const response = await toast.promise(fetchPromise, {
    error: "Error when fetching",
    pending: `Adding ${cardType} to route`,
    success: `${cardType} was added successfully`,
  });
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  const json = response.data;
  return {
    Supplier: json.RoutingForSupplierGsdb as FtlRoutingViewModel,
    Plant: json.RoutingForPlantGsdb as FtlRoutingViewModel,
  };
};

export default getRoutingInfo;
